module.exports = __webpack_public_path__ + "img/logo.e8cad764.png";